/** Query parameter the feedback widget needs to switch itself on outside Brafton hosts. */
export const WIDGET_ACTIVATION_PARAM = 'brafton-feedback';

/**
 * The link an app user follows to a page under review: the page's URL as stored,
 * plus `?brafton-feedback=true` when the page's host wouldn't otherwise load the
 * feedback widget. Mirrors the widget's own rule (`shouldActivateWidget` in the
 * feedback-component repo): it switches on by itself only on localhost and on
 * brafton.com and its subdomains — except the public www.brafton.com.
 *
 * The URL's own query and #fragment are kept exactly (as the backend's
 * EmailLinkBuilder::pageReviewUrl does), and the parameter is never added twice.
 * Anything that isn't an http(s) URL is returned unchanged.
 */
export function pageReviewLink(pageUrl: string): string {
  let parsedUrl: URL;
  try {
    parsedUrl = new URL(pageUrl);
  } catch {
    return pageUrl;
  }
  if (!/^https?:$/.test(parsedUrl.protocol) || activatesWithoutParam(parsedUrl.hostname.toLowerCase())) {
    return pageUrl;
  }
  if (parsedUrl.searchParams.get(WIDGET_ACTIVATION_PARAM) === 'true') {
    return pageUrl;
  }

  const fragmentPosition = pageUrl.indexOf('#');
  const fragment = fragmentPosition === -1 ? '' : pageUrl.slice(fragmentPosition);
  const withoutFragment = fragmentPosition === -1 ? pageUrl : pageUrl.slice(0, fragmentPosition);
  const separator = withoutFragment.includes('?') ? '&' : '?';

  return `${withoutFragment}${separator}${WIDGET_ACTIVATION_PARAM}=true${fragment}`;
}

/** Hosts where the widget switches on without the parameter. */
function activatesWithoutParam(hostname: string): boolean {
  const isLoopback =
    hostname === 'localhost' || hostname.endsWith('.localhost') || hostname === '127.0.0.1' || hostname === '[::1]';
  // Leading dot in the suffix check so `notbrafton.com` doesn't match.
  const isBraftonHost = hostname === 'brafton.com' || hostname.endsWith('.brafton.com');

  return isLoopback || (isBraftonHost && hostname !== 'www.brafton.com');
}
